import React from 'react';
import { OrderHistoryComponent } from './OrderHistoryComponent';
import { Customer } from '../../../../../core-module/services/logistics/types';
import { useSalesOrderHistory } from '../../../../../core-module/hooks/useSalesOrderHistory';
import { Spin } from 'antd';
import { Delivery } from '../../../../../core-module/models/OrderHistory/OrderHistory';

interface Props {
  readonly customer: Customer;
  readonly onEditClick: (delivery: Delivery) => void;
}

const OrderHistoryContainer: React.FC<Props> = ({ customer, onEditClick }) => {
  const salesOrderHistory = useSalesOrderHistory(customer.customer_id);
  if (salesOrderHistory.loading) {
    return <Spin spinning={true}>Bestelhistorie aan het ophalen...</Spin>;
  }
  if (salesOrderHistory.error) {
    return <p>Er is een fout opgetreden bij het ophalen van de bestelhistorie.</p>;
  }

  return (
    <OrderHistoryComponent
      deliveries={salesOrderHistory.deliveries}
      customer={customer}
      metadata={salesOrderHistory.metadata}
      pageNumber={salesOrderHistory.pageNumber}
      onNextPage={salesOrderHistory.nextPage}
      onPrevPage={salesOrderHistory.prevPage}
      onEditClick={onEditClick}
    />
  );
};

export { OrderHistoryContainer };
